/*
 * Copyright © 2021-present Tacnode Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Tacnode Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Tacnode Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { Table } from 'antd'
import { useProductPurchasesColumns } from '@/pages/billing/StatementDetail/ProductPurchases/useProductPurchasesColumns'
import { RouteSupplyData } from '@/routes/RouteSupplyData'

export function ProductPurchases() {
  const { data: statementDetail } = RouteSupplyData.useContext('statementId')
  const columns = useProductPurchasesColumns()

  return <Table dataSource={statementDetail.statementData.skuAndAmounts} columns={columns} rowKey={() => Math.random()} pagination={false} />
}
